
class PodcastBannerSlider {
  constructor (parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.init();
  }
  submitEvent = () => {
    let customForm = document.querySelector(".custom-form");
    if (customForm) {
      customForm.addEventListener("submit", (e) => {
        e.preventDefault();
        let subscribeBtn = customForm.querySelector(".subscribe-btn");
        subscribeBtn.classList.add("remove-text");
        let loader = customForm.querySelector(".loader4");
        loader.style.opacity = 1;
        let email = customForm["email_id"].value;
        let flag = 1;
        if (!this.validateEmail(email)) {
          flag = 0;
          customForm["email_id"].value = '';
          customForm["email_id"].focus();
          document.querySelector(".email-error-msg").classList.add("active");
        }
        if (flag) {
          document.querySelector(".email-error-msg").classList.remove("active");
          setTimeout(() => {
            document.querySelector(".subscribe-text").classList.add('active');
          }, 3000);
        }
        setTimeout(() => {
          loader.style.opacity = 0;
          subscribeBtn.classList.remove("remove-text");
        }, 3000);
      })
    }
  }
  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  videoLoad = () =>{
    let videos = document.querySelectorAll('.videos-list-items .video-item');
    videos.forEach((item)=>{
      item.addEventListener('click',(e)=>{
        let videoItem = e.currentTarget;
        let url = e.currentTarget.dataset?.src;
        let description = videoItem.querySelector('.description');
        let descDiv =  document.querySelector('.podcast-youtube-section-main .video-desc-section .description-main');
        if(url){
          let videoIframe = document.querySelector('.podcast-youtube-section-main .video-desc-section iframe.video-frame');
          if(videoIframe){
            videoIframe.src = url;
          }
          if(descDiv){
            if(description){
              descDiv.innerHTML = description.innerHTML;
            }else{
              descDiv.innerHTML = "";
            }
          }
        }
      })
    })
  }

  slider = () => {
    let sliders = qsa('.podcast-video-slider-js');
    // if (window.innerWidth > 767) {
    //   return false;
    // }
    sliders.forEach(element => {
      // let PodcastBannerSliderSlide = element.dataset.slide;
      let PodcastBannerSliderClass = element;
      this.PodcastBannerSlider(PodcastBannerSliderClass);
    });
  }
  PodcastBannerSlider = (sliderClass) => {
    new Swiper(sliderClass, {
      loop: false,
      slidesPerView: 2,
      autoHeight:true,
      speed: 1000,
      spaceBetween: 5,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
  init = () => {
    this.submitEvent();
    // this.videoSlider();
    this.slider();
    this.PodcastBannerSlider();
    this.videoLoad();
  }
}

new PodcastBannerSlider(document.querySelector('.podcast-youtube-section-main'));